export const directoryMessages = {
  cs: {
    "directory.metaTitle": "Klientské portály",
    "directory.title": "Objevujte klientské portály",
    "directory.openPortal": "Prohlédnout nabídku",
    "directory.description": "Najděte svůj prostor pro služby, rezervace a spolupráci. Prohlédněte si veřejné klientské portály na TAKERES.",
    "directory.discover": "Objevovat",
    "directory.all": "Všechny portály",
    "directory.allDescription": "Najděte svůj prostor pro služby a spolupráci.",
    "directory.category.coach.title": "Trénink a koučink",
    "directory.category.coach.description": "Najděte podporu pro svůj pohyb, cíle a osobní rozvoj.",
    "directory.category.booking.title": "Rezervace a služby",
    "directory.category.booking.description": "Objevte služby a vyberte si čas, který vám vyhovuje.",
    "directory.back": "Zpět na objevování",
    "directory.skip": "Přejít na obsah",
    "directory.authError": "Přihlášení se nepodařilo dokončit. Zkuste se prosím přihlásit znovu.",
    "directory.searchLabel": "Hledat klientský portál",
    "directory.searchPlaceholder": "Název portálu nebo jeho adresa…",
    "directory.search": "Hledat",
    "directory.categories": "Kategorie portálů",
    "directory.searchResults": "Portály odpovídající „{search}“",
    "directory.clearSearch": "Zrušit hledání",
    "directory.loadError": "Portály se nepodařilo načíst",
    "directory.retryHint": "Zkuste to prosím za chvíli znovu.",
    "directory.retry": "Zkusit znovu",
    "directory.noSearchResults": "Tady jsme žádný portál nenašli",
    "directory.emptyCategory": "V této kategorii zatím nejsou žádné portály",
    "directory.emptyPage": "Na této stránce nejsou žádné portály",
    "directory.emptyDirectory": "Nové portály se tu brzy objeví",
    "directory.noResultsHint": "Zkuste jiný název nebo si prohlédněte všechny veřejné portály.",
    "directory.directLinkHint": "Pokud už máte odkaz od svého poskytovatele, můžete jeho portál otevřít přímo.",
    "directory.browseAll": "Prohlédnout všechny portály",
    "directory.pagination": "Stránkování portálů",
    "directory.previous": "Předchozí",
    "directory.next": "Další",
    "directory.page": "Stránka {page}",
    "directory.previousPortals": "Předchozí portály: {title}",
    "directory.nextPortals": "Další portály: {title}",
    "directory.portalGroup": "Portály: {title}",
    "directory.privateHint": "Soukromé portály otevřete přes přímý odkaz od svého poskytovatele nebo z e-mailové pozvánky.",
    "directory.footer": "Váš prostor pro služby a spolupráci.",
  },
  en: {
    "directory.metaTitle": "Client portals",
    "directory.title": "Discover client portals",
    "directory.openPortal": "Explore the portal",
    "directory.description": "Find your space for services, bookings and collaboration. Browse public client portals on TAKERES.",
    "directory.discover": "Discover",
    "directory.all": "All portals",
    "directory.allDescription": "Find your space for services and collaboration.",
    "directory.category.coach.title": "Training and coaching",
    "directory.category.coach.description": "Find support for your fitness, goals and personal growth.",
    "directory.category.booking.title": "Bookings and services",
    "directory.category.booking.description": "Explore services and choose a time that works for you.",
    "directory.back": "Back to discovery",
    "directory.skip": "Skip to content",
    "directory.authError": "Sign-in could not be completed. Please try signing in again.",
    "directory.searchLabel": "Find a client portal",
    "directory.searchPlaceholder": "Portal name or address…",
    "directory.search": "Search",
    "directory.categories": "Portal categories",
    "directory.searchResults": "Portals matching “{search}”",
    "directory.clearSearch": "Clear search",
    "directory.loadError": "Portals could not be loaded",
    "directory.retryHint": "Please try again in a moment.",
    "directory.retry": "Try again",
    "directory.noSearchResults": "No portals found",
    "directory.emptyCategory": "There are no portals in this category yet",
    "directory.emptyPage": "There are no portals on this page",
    "directory.emptyDirectory": "New portals will appear here soon",
    "directory.noResultsHint": "Try another name or browse all public portals.",
    "directory.directLinkHint": "If you already have a link from your provider, you can open their portal directly.",
    "directory.browseAll": "Browse all portals",
    "directory.pagination": "Portal pages",
    "directory.previous": "Previous",
    "directory.next": "Next",
    "directory.page": "Page {page}",
    "directory.previousPortals": "Previous portals: {title}",
    "directory.nextPortals": "Next portals: {title}",
    "directory.portalGroup": "Portals: {title}",
    "directory.privateHint": "Open private portals using a direct link from your provider or an email invitation.",
    "directory.footer": "Your space for services and collaboration.",
  },
} as const;
